import type { ValueOf } from 'type-fest';

const VERIFICATION_STEPS = {
  ADD_CONTENT: 'addContent',
  GET_VERIFICATION_CODE: 'getVerificationCode',
  VERIFICATION_CODE_SENT: 'verificationCodeSent',
  VERIFICATION_SUCCESS: 'verificationSuccess',
} as const;

const MODES = {
  PHONE: 'phone',
  EMAIL: 'email',
} as const;

const DEFAULT_VERIFICATION_CONFIG = [
  VERIFICATION_STEPS.ADD_CONTENT,
  VERIFICATION_STEPS.GET_VERIFICATION_CODE,
  VERIFICATION_STEPS.VERIFICATION_CODE_SENT,
  VERIFICATION_STEPS.VERIFICATION_SUCCESS,
];

export type MODES_VALUES = ValueOf<typeof MODES>;

export { MODES, VERIFICATION_STEPS, DEFAULT_VERIFICATION_CONFIG };
